<mat-chip-list class="interests-dialog__form__chips" [multiple]="true" [selectable]="true">
  <mat-chip
    *ngFor="let response of question.availableResponsesForCurrentLevel; let i = index"
    #chip="matChip"
    [selected]="question.userResponsesForCurrentLevel.includes(response.uuid)"
    (click)="chipClickedHandler(chip)"
    [value]="response.uuid"
    [disableRipple]="true">
    {{ response.text }}
  </mat-chip>
</mat-chip-list>
